import type { Display } from './get-box-styles';

export const filterDisplayProps = ({
  variant,
  alignContent,
  stack,
}: Pick<Display, 'variant' | 'alignContent' | 'stack'>) =>
  variant === 'initial'
    ? {
        variant,
      }
    : variant === 'grid'
      ? {
          variant,
          alignContent,
        }
      : ({
          variant,
          alignContent,
          stack,
        } satisfies Display);
